// extracted by mini-css-extract-plugin
export default {"root":"chat_subheader___root___b01b4c04","back":"chat_subheader___back___a3caf282","title":"chat_subheader___title___e6aa6f94","center":"chat_subheader___center___e15d34a7"};